import React, { Dispatch, SetStateAction, useState } from 'react';
import { FilterParams } from '../../../../interfaces/Filter';
import Button from '../../../../components/button/Button';
import Input from '../../../../components/input/Input';
import { Dropdown, MenuProps, Select } from 'antd';
import { FilterIcon } from '../../../../components/icons';
import CustomModal from '../../../../components/CustomModal';
import { useBusinessRoles } from '../../../../customhooks/useBusinessRoles';

const FilterTeamMembers = ({
    filterOptions,
    setFilterOptions
}: {
    filterOptions: FilterParams;
    setFilterOptions: Dispatch<SetStateAction<FilterParams>>;
}) => {
    const [tempFilterOptions, setTempFilterOptions] = useState<FilterParams>(
        filterOptions
    );

    const { isLoading: isRolesLoading, businessRoles } = useBusinessRoles({
        page: 0,
        size: 0
    });

    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const handleApply = () => {
        setFilterOptions(tempFilterOptions);
        setDropdownVisible(false);
        setModalVisible(false);
    };

    const roleOptions =
        businessRoles?.map((role) => ({
            label: role.name,
            value: role.id
        })) || [];

    const items = [
        {
            key: '1',
            label: (
                <p className='text-ebony text-base leading-[20px] pt-4 '>
                    Filters
                </p>
            )
        },
        {
            key: '2',
            label: (
                <div>
                    <label className='text-sm font-medium text-steelBlue  block mb-2'>
                        Name
                    </label>

                    <Input
                        type='text'
                        value={tempFilterOptions?.search}
                        style={{ height: '40px' }}
                        placeholder='Enter name'
                        onChange={(e) => {
                            e.preventDefault();
                            setTempFilterOptions({
                                ...tempFilterOptions,
                                search: e.target.value
                            });
                        }}
                    />
                </div>
            )
        },
        {
            key: '3',
            label: (
                <div className='mt-[16px] lg:mt-0'>
                    <label className='text-sm text-steelBlue block mb-2'>
                        Role
                    </label>

                    <Select
                        className='h-[40px] w-full'
                        onChange={(value: string) =>
                            setTempFilterOptions({
                                ...tempFilterOptions,
                                role: value
                            })
                        }
                        value={tempFilterOptions?.role}
                        options={roleOptions}
                        loading={isRolesLoading}
                        size='large'
                    />
                </div>
            )
        },
        {
            key: '4',
            label: (
                <div>
                    <label className='text-sm font-medium text-steelBlue  block mb-2'>
                        Email Address
                    </label>

                    <Input
                        type='email'
                        value={tempFilterOptions?.email}
                        style={{ height: '40px' }}
                        placeholder='Enter email address'
                        onChange={(e) =>
                            setTempFilterOptions({
                                ...tempFilterOptions,
                                email: e.target.value
                            })
                        }
                    />
                </div>
            )
        },
        {
            key: '6',
            label: (
                <div className='flex justify-between py-4'>
                    <Button
                        text='Cancel'
                        onClick={() => setDropdownVisible(false)}
                        variant='secondaryOutline'
                        size='sm'
                    />
                    <div className='flex gap-[16px]'>
                        <button
                            className='text-steelBlue text-xs leading-[20px]'
                            onClick={() => {
                                const clearedFilters = {
                                    page: 0,
                                    size: 10,
                                    search: '',
                                    name: '',
                                    email: '',
                                    role: undefined
                                };

                                setTempFilterOptions(clearedFilters);
                                setFilterOptions(clearedFilters);
                                setDropdownVisible(false);
                                setModalVisible(false);
                            }}
                        >
                            Reset
                        </button>
                        <Button
                            text='Apply Filter'
                            onClick={handleApply}
                            size='sm'
                        />
                    </div>
                </div>
            )
        }
    ];

    const handleButtonClick = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const dropdownItems = items as MenuProps['items'];

    return (
        <>
            <div className='hidden lg:block'>
                <Dropdown
                    menu={{
                        items: dropdownItems
                    }}
                    placement='bottomRight'
                    autoAdjustOverflow={false}
                    trigger={['click']}
                    open={dropdownVisible}
                    overlayStyle={{
                        pointerEvents: 'auto'
                    }}
                    dropdownRender={(menu) => (
                        <div className='w-[375px] h-[467px]'>
                            {React.cloneElement(menu as React.ReactElement)}
                        </div>
                    )}
                >
                    <Button
                        leftIcon={<FilterIcon />}
                        text='Filter'
                        variant='secondaryOutline'
                        onClick={handleButtonClick}
                    />
                </Dropdown>
            </div>

            <div className='lg:hidden '>
                <CustomModal
                    isModalOpen={modalVisible}
                    onClose={() => setModalVisible(false)}
                    hideCloseIcon
                >
                    <div className='space-y-4 h-[45vh] p-5'>
                        {items?.map((item) => item?.label)}
                    </div>
                </CustomModal>

                <Button
                    leftIcon={<FilterIcon />}
                    text='Filter'
                    variant='secondaryOutline'
                    onClick={() => setModalVisible(true)}
                    size='md'
                />
            </div>
        </>
    );
};

export default FilterTeamMembers;
